export default __webpack_public_path__ + "static/media/resume.686c0b77.pdf";